//import { ReactComponent as MoreVertical } from '../assets/icons/more-vertical.svg';
//import { ReactComponent as MoreHorizontal } from '../assets/icons/more-horizontal.svg';
//export { ReactComponent as MoreVertical } from '../assets/icons/more-vertical.svg';
//export { ReactComponent as MoreHorizontal } from '../assets/icons/more-horizontal.svg';
// export { default as MoreVertical } from '../assets/icons/more-vertical.svg';
// export { default as MoreHorizontal } from '../assets/icons/more-horizontal.svg';

import { ReactComponent as IconMoreVertical } from '../assets/icons/more-vertical.svg';
import { ReactComponent as IconMoreHorizontal } from '../assets/icons/more-horizontal.svg';
export namespace XIcons {
    export const MoreVertical = IconMoreVertical;
    export const MoreHorizontal = IconMoreHorizontal;
    // export {
    //     MoreVertical,
    //     MoreHorizontal,
    // };

    // export { default as MoreVertical } from '../assets/icons/more-vertical.svg';
    // export { default as MoreHorizontal } from '../assets/icons/more-horizontal.svg';
}

export default XIcons;
//export type Icons = typeof Icons;

// eslint-disable-next-line import/no-anonymous-default-export
//export default namespace XIcons;
// export { 
//     XIcons.MoreHorizontal,
//     IconMoreVertical,
//     IconMoreHorizontal
// };
//export default Icons;
// export default {
//     MoreVertical,
//     MoreHorizontal,
// };

//export default (*);